import 'core-js' // polyfills
import DI, { initialize as initializeDI } from './app/di'
import { get as getAppEnv } from './app/env'

async function main() {
  await initializeDI(DI, getAppEnv())
  const app = require('./app')
  app.init(process.env.NODE_ENV || 'production')
}

main()
